import { useState, useEffect, useRef } from "react";
import { useNotifications } from "../../utils/useNotifications";

const TYPE_ICONS = {
  status_change: "🚢",
  arrival:       "⚓",
  delay:         "⚠️",
  task:          "📋",
};

export default function NotificationBell({ authToken }) {
  const [open, setOpen] = useState(false);
  const { notifications, unreadCount, markRead, markAllRead } = useNotifications(authToken);
  const notification_ref = useRef(null);

  useEffect(() => {
        function handleClickOutside(event) {
            if (notification_ref.current && !notification_ref.current.contains(event.target)) {
            setOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

  return (
    <div style={{ position: "relative" }}>
      <button className="btn" onClick={() => setOpen((o) => !o)} style={{ position: "relative", top: 12, right: -5 }}>
        <i className="fa fa-bell fa-lg text-inox-green"></i>
        {unreadCount > 0 && (
          <span style={{
            position: "absolute", top: -4, right: -4,
            background: "#e24b4a", color: "#fff",
            borderRadius: "999px", fontSize: 11,
            padding: "1px 5px", fontWeight: 500,
          }}>
            {unreadCount}
          </span>
        )}
      </button>

      {open && (
        <div ref={notification_ref} className="bd-highlight" style={{
          position: "absolute", right: 0, top: "110%",
          width: 340, maxHeight: 420, overflowY: "auto",
          background: "#FFF",
          border: "1px solid #CFCFCF",
          borderRadius: 12, 
          boxShadow: "0 4px 16px rgba(0,0,0,.1)",
          fontSize: "14px",
          zIndex: 1000,
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", padding: "12px 16px" }}>
            <strong>Notifications</strong>
            {unreadCount > 0 && (
              <button className="btn btn-inox-green btn-sm text-white" onClick={markAllRead} style={{ fontSize: 12, color: "var(--color-text-info)" }}>
                Mark all read
              </button>
            )}
          </div>

          {notifications.length === 0 && (
            <p style={{ padding: "16px", color: "var(--color-text-secondary)", textAlign: "center" }}>
              All caught up!
            </p>
          )}

          {notifications.map((n) => (
            <div
              key={n.id}
              onClick={() => !n.is_read && markRead(n.id)}
              style={{
                padding: "12px 16px",
                borderTop: "1px solid var(--color-border-tertiary)",
                background: n.is_read ? "lightgrey" : "#FFF",
                cursor: n.is_read ? "default" : "pointer",
                display: "flex", gap: 10, alignItems: "flex-start",
              }}
            >
              <span style={{ fontSize: 18 }}>{TYPE_ICONS[n.notif_type] ?? "🔔"}</span>
              <div>
                <div className="text-inox-green fw-bold" style={{ fontWeight: 500, fontSize: 14, textAlign: 'left' }}>{n.title}</div>
                <div className="text-secondary" style={{ fontSize: 13, textAlign: 'left' }}>{n.message}</div>
                <div style={{ fontSize: 11, textAlign: 'left', marginTop: 2 }}>
                  {new Date(n.created_at).toLocaleString()}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}